module.exports = __webpack_public_path__ + "img/yellowgold.aad76ee.webp";